// extracted by mini-css-extract-plugin
export default {"Container":"CakeIcingCounter_Container__4zu4l","CalculateModeCheckboxContainer":"CakeIcingCounter_CalculateModeCheckboxContainer__+fPZB"};